import PropTypes from 'prop-types';
import Immutable from 'immutable';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { TableRow, TableCell } from '@mui/material';

import shallowEqual from 'app/lib/shallow-equal';
import i18n from 'app/common/i18n';
import { dateToText } from '../../utils/helpers';
import ProfileDialog from './profileDialog';
import RentalPreferenceDialog from './rentalPreferenceDialog';
import SendMessageDialog from './SendMessageDialog';
import InfoModal from '../common/InfoModal';

@connect(() => ({}), {})
@i18n
class StatItem extends Component {
  static propTypes = {
    cellClassName: PropTypes.string,
    item: PropTypes.instanceOf(Immutable.Map).isRequired,
    admin: PropTypes.bool.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !(
      shallowEqual(this.props, nextProps) && shallowEqual(this.state, nextState)
    );
  }

  showAudit = () => {
    this.handleMenuClose();
    this.props.onAuditOpen(this.props.item['uuid']);
  };

  handleMenuOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const {
      item,
      cellClassName,
      user,
      uuid,
      admin,
      onClose
    } = this.props;
    const name = item['name'];
    const email = item['email'];
    const id = item['userId'];
    const activeSince = item['activeSince']
      ? dateToText(item['activeSince'])
      : '-';

    return (
      <TableRow>
        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap', textAlign: 'center' }}
          align="center"
        >
          {item.expanded ? (
            <InfoModal
              label={name}
              title={'Delvis match'}
              message={
                'Denne bruger er fundet ved at udvide søgning, tryk på "BOLIGØNSKER" for at se deres preference'
              }
            />
          ) : (
            name
          )}
        </TableCell>
        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap', textAlign: 'center' }}
        >
          {email}
        </TableCell>
        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap', textAlign: 'center' }}
        >
          {activeSince}
        </TableCell>
        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap', textAlign: 'center' }}
        >
          <ProfileDialog
            id={id}
            email={email}
            icon="person"
            label={this.props.i18n('Profile')}
          />
          <RentalPreferenceDialog
            id={id}
            icon="home"
            label={this.props.i18n('Rental preferences')}
          />
          <SendMessageDialog
            admin={admin}
            onClose={onClose}
            user={user}
            uuid={uuid}
            seekerId={id}
            seekerName={name}
            seekerEmail={email}
            icon="message"
            label={this.props.i18n('Send message')}
          />
        </TableCell>
      </TableRow>
    );
  }
}

export default StatItem;